import RandButton from './RandButton/Component'

const RandButtonPlugin = {
    install(Vue) {
        Vue.component('RandButton', RandButton)
    },
}

export default RandButtonPlugin
